import { Component, Input, OnInit } from '@angular/core';
import { RegStatusEnum } from '../../../../enums/reg-status.enum';
import { Message } from '../../../../classes/Message';
import { TaskService } from '../../../../services';
import { MessageService } from 'primeng';
import {
  JobScreenRecognitionJob,
  JobScreenRecognitionTask,
} from '../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'vme-job-screen-recognition',
  templateUrl: './vme-job-screen-recognition.component.html',
  styleUrls: ['./vme-job-screen-recognition.component.scss'],
})
export class VMEJobScreenRecognitionComponent implements OnInit {
  @Input('jobId') jobId!: number;
  @Input('orderId') orderId!: number;
  @Input('recognitionTask') recognitionTask!: JobScreenRecognitionTask;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  showEditRegStatusDialog: boolean;
  regStatusId: RegStatusEnum;
  job: JobScreenRecognitionJob;
  regStatuses: any[] = [];

  constructor(private messageService: MessageService, private taskService: TaskService) {}

  ngOnInit(): void {
    this.initRegStatuses();
  }

  initRegStatuses() {
    this.regStatuses = [];
    this.regStatuses.push({ label: 'Select status...', value: null });
    this.taskService.getRegStatuses().then((res) => {
      res.forEach((x) => this.regStatuses.push({ label: x.name, value: x.id }));
    });
  }

  editRegStatus(task: JobScreenRecognitionTask) {
    this.regStatusId = task.regStatusId;
    this.showEditRegStatusDialog = true;
  }

  setRegStatusToManualUpdate() {
    this.regStatusId = RegStatusEnum.ManuallyUpdated;
    this.saveRegStatus();
  }

  saveRegStatus() {
    this.recognitionTask.regStatusId = this.regStatusId;

    this.taskService
      .saveRegStatus({
        taskId: this.recognitionTask.id,
        jobId: this.jobId,
        regStatusId: this.regStatusId,
      })
      .then((result) => {
        if (result) {
          let type = this.regStatuses.find((x) => x.value == this.recognitionTask.regStatusId);
          if (type != null) {
            this.recognitionTask.regStatusName = type.label;
          }

          this.showEditRegStatusDialog = false;
          this.messageService.add(Message.Success('Reg Status updated', 'Engineius Movement Type'));
        }
      });
  }
}
